import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@16.2.3_@babel+core@7.28.6_@playwright+test@1.58.2_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/home.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewTracker"] */ "/opt/build/repo/src/components/analytics/PageViewTracker.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/analytics/TrackedLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GroupClassWaitlist"] */ "/opt/build/repo/src/components/courses/GroupClassWaitlist.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthorityLessonVideo"] */ "/opt/build/repo/src/components/home/AuthorityLessonVideo.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoachingProofSection"] */ "/opt/build/repo/src/components/marketing/CoachingProofSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/marketing/TrustStrip.module.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/home/LessonExperience.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["EventAnnouncement"] */ "/opt/build/repo/src/components/webinar/EventAnnouncement.client.tsx");
